import { render, staticRenderFns } from "./CRUDIndex.vue?vue&type=template&id=90fa2822"
import script from "./CRUDIndex.vue?vue&type=script&lang=js"
export * from "./CRUDIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports